var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { AppBar, createTheme } from '@michelin/acid-components';
import { MuiThemeProvider } from '@material-ui/core';
import { LogoHeader } from '../Logo/LogoHeader';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
var drawerWidth = 240;
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c;
    return createStyles({
        root: {
            display: 'flex',
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            background: theme.palette.common.white,
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
        },
        appBarShift: {
            marginLeft: drawerWidth,
            width: "calc(100% - ".concat(drawerWidth, "px)"),
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            marginRight: 36,
        },
        grow: {
            flexGrow: 1,
        },
        hide: {
            display: 'none',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: (_a = {
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                overflowX: 'hidden',
                width: theme.spacing(7) + 1
            },
            _a[theme.breakpoints.up('sm')] = {
                width: theme.spacing(9) + 1,
            },
            _a),
        toolbar: __assign({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '0 8px' }, theme.mixins.toolbar),
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
        sectionDesktop: (_b = {
                display: 'none'
            },
            _b[theme.breakpoints.up('md')] = {
                display: 'flex',
            },
            _b.alignItems = 'center',
            _b),
        sectionMobile: (_c = {
                display: 'flex'
            },
            _c[theme.breakpoints.up('md')] = {
                display: 'none',
            },
            _c),
    });
});
export var CentralProviderHeaderGuest = function (props) {
    var customLink = props.customLink, onNavigate = props.onNavigate, _a = props.logoType, logoType = _a === void 0 ? 'poweredByMichelin' : _a;
    var classes = useStyles(props);
    return (React.createElement(CentralProviderContext.Consumer, null, function (value) { return (React.createElement(React.Fragment, null,
        React.createElement(MuiThemeProvider, { theme: createTheme({ palette: { type: value.currentTheme } }) },
            React.createElement(Box, { className: clsx(classes.appBar) },
                React.createElement(AppBar, { fixed: true },
                    React.createElement(LogoHeader, { onNavigate: onNavigate, logoType: logoType }),
                    React.createElement("div", { style: { display: 'inline-block', flexGrow: 1 } }),
                    React.createElement("div", { className: classes.grow }),
                    React.createElement("div", { className: classes.sectionDesktop },
                        React.createElement("div", { style: { flex: 1, justifyContent: 'flex-end' } }, customLink || null)),
                    React.createElement("div", { className: classes.sectionMobile },
                        React.createElement("div", { style: { flex: 1, justifyContent: 'flex-end' } }, customLink || null)))),
            React.createElement("div", { style: { height: '5rem' } })))); }));
};
//# sourceMappingURL=CentralProviderHeaderGuest.js.map